// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FYPEL","label":"styles_label__RVX3m"};